export const INITIAL_LOAD = 'INITIAL_LOAD';
export const REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR = 'REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR';
export const REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS = 'REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS';
export const REQUEST_WORKOUT_STATS_FAILED = 'REQUEST_WORKOUT_STATS_FAILED';
export const REQUEST_SCAN_STATS_FAILED = 'REQUEST_SCAN_STATS_FAILED';
export const REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS = 'REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS';
export const REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED = 'REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED';
export const REQUEST_WORKOUT_STATS = 'REQUEST_WORKOUT_STATS';
export const REQUEST_WORKOUT_STATS_SUCCESS = 'REQUEST_WORKOUT_STATS_SUCCESS';
export const REQUEST_SCAN_STATS = 'REQUEST_SCAN_STATS';
export const REQUEST_SCAN_STATS_SUCCESS = 'REQUEST_SCAN_STATS_SUCCESS';
export const REQUEST_SCAN_STAT_DATES_SUCCESS = 'REQUEST_SCAN_STAT_DATES_SUCCESS';
export const REQUEST_LATEST_SCAN_STATS = 'REQUEST_LATEST_SCAN_STATS';
export const REQUEST_LATEST_SCAN_STATS_SUCCESS = 'REQUEST_LATEST_SCAN_STATS_SUCCESS';
export const RELOAD_SCAN_STATS_FOR_DASHBOARD = 'RELOAD_SCAN_STATS_FOR_DASHBOARD';
export const SET_SELECTED_SCAN_STATS_DATE = 'SET_SELECTED_SCAN_STATS_DATE';
export const TRACKING_WORKOUT_DATE_CHANGE = 'tracking_workouts_detail_datechanged';
export const TRACKING_HEALTH_DATE_CHANGE = 'tracking_health_detail_datechanged';
export const TRACKING_WORKOUT_DETAIL_OPENED = 'tracking_workouts_detail_opened';
export const TRACKING_HEALTH_DETAIL_OPENED = 'tracking_health_detail_opened';
export const TRACKING_MAIN_TILE_SELECTED = 'tracking_main_tile_selected';
export const TRACKING_HEALTH_HISTORY_OPENED = 'tracking_health_history_opened';
export const TRACKING_WORKOUTS_HISTORY_OPENED = 'tracking_workouts_history_opened';
export const TRACKING_WORKOUTS_HISTORY_WORKOUTOPENED = 'tracking_workouts_history_workoutopened';
export const SHOP_FOR_FITBEAT_GEAR_SELECTED = 'tracking_workouts_shop_opened';
export const REQUEST_WEEKLY_WORKOUT_STATS_REQUEST = 'REQUEST_WEEKLY_WORKOUT_STATS_REQUEST';
export const REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS = 'REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS';
export const REQUEST_WEEKLY_WORKOUT_STATS_FAILURE = 'REQUEST_WEEKLY_WORKOUT_STATS_FAILURE';
export const REQUEST_BODY_METRIC_STATS_REQUEST = 'REQUEST_BODY_METRIC_STATS_REQUEST';
export const REQUEST_BODY_METRIC_STATS_SUCCESS = 'REQUEST_BODY_METRIC_STATS_SUCCESS';
export const REQUEST_BODY_METRIC_STATS_FAILURE = 'REQUEST_BODY_METRIC_STATS_FAILURE';
export const LOAD_TRACKING_DATA_FOR_DASHBOARD = 'LOAD_TRACKING_DATA_FOR_DASHBOARD';
export const LOAD_LEADERBOARDS_REQUEST = 'LOAD_LEADERBOARDS_REQUEST';
export const LOAD_LEADERBOARDS_SUCCESS = 'LOAD_LEADERBOARDS_SUCCESS';
export const LOAD_LEADERBOARDS_FAILURE = 'LOAD_LEADERBOARDS_FAILURE';
export const LOAD_INACTIVE_LEADERBOARDS_REQUEST = 'LOAD_INACTIVE_LEADERBOARDS_REQUEST';
export const LOAD_INACTIVE_LEADERBOARDS_SUCCESS = 'LOAD_INACTIVE_LEADERBOARDS_SUCCESS';
export const LOAD_INACTIVE_LEADERBOARDS_FAILURE = 'LOAD_INACTIVE_LEADERBOARDS_FAILURE';
export const LOAD_USER_BREAKDOWN_REQUEST = 'LOAD_USER_BREAKDOWN_REQUEST';
export const LOAD_USER_BREAKDOWN_SUCCESS = 'LOAD_USER_BREAKDOWN_SUCCESS';
export const LOAD_USER_BREAKDOWN_FAILURE = 'LOAD_USER_BREAKDOWN_FAILURE';
export const OPT_OUT_OF_LEADERBOARD = 'OPT_OUT_OF_LEADERBOARD';
export const OPT_OUT_OF_LEADERBOARD_REQUEST = 'OPT_OUT_OF_LEADERBOARD_REQUEST';
export const OPT_OUT_OF_LEADERBOARD_SUCCESS = 'OPT_OUT_OF_LEADERBOARD_SUCCESS';
export const OPT_OUT_OF_LEADERBOARD_FAILURE = 'OPT_OUT_OF_LEADERBOARD_FAILURE';
export const CLOSE_OPT_OUT_LEADERBOARD_MODAL = 'CLOSE_OPT_OUT_LEADERBOARD_MODAL';
